import React from 'react';
// import OgogdolOruulah from './ogogdolOruulah';
import OgogdolOruulah from './ogogdolOruulah/newUgugdulOruulah';

const PageList = () => <OgogdolOruulah />;

export default PageList;
